const urls = {
  getServer: '/server',
  getUserRegistration: '/email',
  login: '/login-ppt',
  ssoStatus: (sessionId: string) => `/sso-status?sessionId=${sessionId}`,
  ssoLogin: '/login-ppt-sso',
  logout: '/logout',
  getProfileAvatar: '/users/profile/avatar/get',
} as const;

export default urls;
